import Axios from "axios";

export default function getReqCompanies(
  setCompanies,
  setPaginationResult,
  page = 0
) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/get-reqCompanies`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        page: page,
      },
    })
      .then((response) => {
        setCompanies(response.data.data);
        setPaginationResult(response?.data?.pagination);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
